import { WidgetType } from './widgetType';
export const DividerWidgetHelper = {
    isDividerWidget: (widget) => {
        return widget.value.type === WidgetType.divider;
    },
    isDividerServerData(widget) {
        return widget.type === WidgetType.divider;
    },
    makeDefaultProperties: () => ({
        displayDelayInSeconds: 0,
        color: '#9B9B9B',
        thickness: 's',
    }),
    createDivider: () => ({
        type: WidgetType.divider,
        data: {},
        properties: DividerWidgetHelper.makeDefaultProperties(),
    }),
};
